import React from 'react';
import { MessagingModal } from '@uplift/ui-v2';
import { useFeatureFlag } from '@uplift/hooks';


export const PatientMessagingModal = () => {
  const ff = useFeatureFlag('IN_APP_MESSAGING');

  if (!ff) return null;

  return (
    <MessagingModal color="primary" />
  );
};
